import React, { Component } from "react"
import { connect } from "react-redux"
import { closeMessage, clearLockersStatuses } from "../../../actions"
import LockerCells from "../../common/LockerCells"
import { ButtonRectangle } from "../../common/ButtonRectangle"
import "./style.scss"

class StationStatusScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentWillUnmount() {
    this.props.clearLockersStatuses()
  }

  componentDidMount() {
    if (!this.props.authenticated) {
      this.props.history.push("/")
    }
  }

  render() {
    let {} = this.state
    const { stationId } = this.props

    return (
      <div className="station-status-wrapper">
        <div className="btn-back-wrapper">
          <ButtonRectangle
            extraClass="btn-back"
            onClick={() => this.props.history.goBack()}
          >
            חזור
          </ButtonRectangle>
        </div>

        <LockerCells stationId={stationId} />
      </div>
    )
  }
}

const mapStateToProps = ({ users }) => {
  const { authenticated, userData } = users

  const { stationId } = userData
  return {
    authenticated,
    stationId,
  }
}

export default connect(mapStateToProps, {
  closeMessage,
  clearLockersStatuses,
})(StationStatusScreen)
